/* lua.js generated code 0.3.0 */

BaseRedirector = xClass("BaseRedirector")
BaseRedirector.prototype.ctor = function (scheme, api, param, source, shareTicket) {
    var self = this
    self.scheme = scheme
    self.api = api
    self.param = param
    self.source = source
    self.shareTicket = shareTicket
}
BaseRedirector.prototype.getName = function () {
    var self = this
    assert(false, "not implement BaseRedirector:getName()!")
}
// 是否有高优先级行为，例如弹窗
// 有高优先级行为的Redirector不会被新手直进关卡等中断
// 后台请求，数据操作，tip则不属于此列
BaseRedirector.prototype.hasHighPriorityAction = function () {
    return true
}
// if redirect proccess success return true. otherwise cache redirect
// 如有面板展示，为了避免和HomeScenePopoutQueue冲突，可直接返回Promise，会先于queque执行
BaseRedirector.prototype.redirect = function () {
    var self = this
    printf("redirect:%s", self.getName())
    for (var k in self.param) {
        var v = self.param[k]
        cc.log(k, v)
    }
    printf("BaseRedirector:redirect(%s, %s, %s)", self.scheme, self.api, self.source)
    return true
}
